// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { AssetBreadCrumb, AssetSearch } from '../SelectImage';
import { ListView } from './View/ListView';
import { ThumbnailView } from './View/UploadThumbnailView'
import { Asset } from 'components/AssetPicker/utils/types';

const emptyStyle = {
  color: '#4a5568',
  fontSize: '1.375rem',
  fontWeight: '800',
  letterSpacing: '-.00019em',
  lineHeight: '1.6875rem',
  marginTop: 0,
}

export const NoAssets = ({ length, children }) => {
  return length === 0 ? (
    <div style={{ textAlign: 'center', height: '292px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <p style={emptyStyle}>No Records Found</p>
    </div>
  ) : children
}

function UploadImage(props: any) {
  const { getFolders, users, createFolder, getFilesFromFileSystem, permissions, folderUid, assets, setAssets } = props;
  const [displayType, setDisplayType] = useState<"list" | "grid">(props?.displayType || "list")
  const [paginationData, setPaginationData] = useState({
    skip: null,
    limit: 0,
    startIndex: 0,
    stopIndex: 12,
    query: ""
  });
  const [selectedAsset, setSelectedAsset] = useState<Asset>({});

  const [path, setPath] = useState(() => ({
    breadcrumbs: [{
      uid: "cs_root",
      displayName: 'All Assets',
      action: (_idx: number, uid: string) => {
        setPath((prev) => ({
          breadcrumbs: prev.breadcrumbs.slice(0, 1),
          folderUid: 'cs_root'
        }))
      }
    }],
    folderUid: "cs_root"
  }))

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchOnChange({ skip: 0, limit: 12, startIndex: 0, stopIndex: 12 })
  }, [paginationData.query, path.folderUid]);

  const fetchOnChange = async ({ sortBy = null, skip, limit, startIndex, stopIndex }) => {
    const instanceItemStatusMapped = {};

    for (let i = startIndex; i <= stopIndex; i++) {
      instanceItemStatusMapped[i] = 'loading';
    }

    setLoading(true)
    setAssets((prev) => ({ ...prev, items: [], itemStatusMap: { ...instanceItemStatusMapped } }))


    let sort: { id: "string", order: "asc" | "desc" } | undefined;
    if (sortBy && sortBy.id && sortBy.sortingDirection) {
      sort = {
        id: sortBy.id,
        order: sortBy.sortingDirection,
      };
    }

    let response: Record<string, any>
    try {

      response = await getFolders({ limit, skip, query: paginationData.query, folderUid: path.folderUid, sort });
    }
    catch (error) {
      console.error(`'openUploadAssetModal' Failed to get assets using 'getAssets' - ${error.message}`)
    }

    for (let i = startIndex; i <= stopIndex + 1; i++) {
      instanceItemStatusMapped[i] = 'loaded'
    }

    if (response && response.assets && Array.isArray(response.assets)) {
      setAssets({
        items: response.assets,
        itemStatusMap: { ...instanceItemStatusMapped },
        count: response.count
      });
    }

    setPaginationData((prev) => ({
      ...prev,
      startIndex,
      stopIndex,
      skip: skip || 0,
      limit: limit || 12
    }));

  }

  const loadMore = async ({ sortBy = null, skip, limit, startIndex, stopIndex }) => {
    if (stopIndex <= paginationData.stopIndex || (paginationData.skip === skip && paginationData.limit === limit)) return;
    skip = paginationData.skip + paginationData.limit
limit = Math.min(assets.count - skip, 12);
    let sort: { id: "string", order: "asc" | "desc" } | undefined;
    if (sortBy && sortBy.id && sortBy.sortingDirection) {
      sort = {
        id: sortBy.id,
        order: sortBy.sortingDirection,
      };
    }

    let response: Record<string, any>;
    try {
      response = await getFolders({ limit, skip, query: paginationData.query, folderUid: path.folderUid, sort });
    }
    catch (error) {
      console.error(`'openUploadAssetModal' Failed to load more assets using 'getAssets' - ${error.message}`)
    }

    const instanceItemStatusMapped = {};
    for (let i = startIndex; i <= stopIndex + 1; i++) {
      instanceItemStatusMapped[i] = 'loaded'
    }

    if (response && response.assets && Array.isArray(response.assets)) {
      setAssets((prev) => ({
        ...prev,
        items: [...prev.items, ...response.assets],
        itemStatusMap: { ...prev.itemStatusMap, ...instanceItemStatusMapped },
        count: response?.count
      }));
    }
    setPaginationData((prev) => ({
      ...prev,
      startIndex,
      stopIndex,
      skip,
      limit
    }))

  }

  const handleClick = (asset: Asset & Record<string, any>) => {
    if (props.setFolderUid) {
      props.setFolderUid(asset.uid);
    }

    setPath((prev) => ({
      ...prev,
      breadcrumbs: [...prev.breadcrumbs, {
        displayName: asset.name,
        action: (breadcrumbIndex: number) => {
          setPath(prevState => {
            return {
              ...prevState,
              breadcrumbs: prevState.breadcrumbs.slice(0, breadcrumbIndex + 1),
              folderUid: asset.uid
            }
          });
        }
      }],
      folderUid: asset.uid
    }));
  }

  const loadMoreGrid = () => {
    const skip = paginationData.stopIndex;
    const limit = 12;
    const startIndex = paginationData.stopIndex + 1;
    const stopIndex = startIndex + limit;
    loadMore({ skip, startIndex, limit, stopIndex });
  }

  const createFolderWithName = async ({ folderName }: { folderName: string }) => {
    const folderUid = path.folderUid === 'cs_root' ? null : path.folderUid;

    try {
      const res = await createFolder({ parentUid: folderUid, folderName: folderName });
      if (res) {
        setAssets((prev) => ({
          ...prev,
          items: [...prev.items, res.asset],
          count: prev.count + 1,
        }));
      }
    }
    catch (err) {
      console.error(`'openUploadAssetModal': failed to create folder using 'createFolder' - ${err.message}`)
    }
  }



  return (
    <div style={{ fontFamily: 'Inter' }}>
      <AssetBreadCrumb breadcrumbs={path.breadcrumbs} />
      <AssetSearch
        listType={displayType}
        onDisplayTypeChange={(displayType: string) => {
          if (props?.onDisplayTypeChange) {
            props?.onDisplayTypeChange(displayType)
          }
          setDisplayType(displayType)
        }}
        onQueryChange={(queryText: string) => setPaginationData((prev) => ({ ...prev, query: queryText }))}
        assetsCount={assets.count}
        showSearchBox={true}
      />
      {
        displayType === 'list' ?
          <ListView
            folderUid={folderUid}
            loading={loading}
            permissions={permissions}
            assets={assets.items}
            selectedAsset={selectedAsset}
            assetsCount={assets.count}
            itemStatusMap={assets.itemStatusMap}
            users={users}
            createFolder={createFolderWithName}
            handleClick={handleClick}
            fetchOnChange={fetchOnChange}
            loadMore={loadMore}
            minBatchSizeToFetch={12}
          /> :
          <ThumbnailView
            folderUid={path.folderUid}
            selectedAsset={selectedAsset}
            assets={assets.items}
            assetsCount={assets.count}
            createFolder={createFolderWithName}
            permissions={permissions}
            handleClick={handleClick}
            multiple={props.multiple}
            size={props.size}
            fileTypes={props.fileTypes}
            handleUpload={props.handleUpload}
            loadMoreGrid={loadMoreGrid}
            getFilesFromFileSystem={getFilesFromFileSystem}
          />
      }
    </div>
  )
}



export default UploadImage;
